import Card from "../components/Card";

const samplePrompt = `You are an HR analyst. Summarize evaluation results in Thai with concise bullet points.
Input includes numeric scores and free-text feedback.
Return JSON with fields: summary, strengths[], developmentAreas[], recommendations[].
Keep to <180 words. Avoid repeating input text. Focus on actionable insights.`;

function AiSummary() {
  return (
    <div className="space-y-6">
      <div>
        <p className="text-sm text-slate-500">AI Agent</p>
        <h2 className="text-2xl font-semibold text-slate-900">Prompt-based insights</h2>
      </div>

      <Card title="Example prompt" subtitle="LLM call for individual summary">
        <pre className="whitespace-pre-wrap text-sm text-slate-800 bg-slate-50 border border-slate-200 rounded-md p-3">
          {samplePrompt}
        </pre>
      </Card>

      <Card title="Why prompt-based?" subtitle="Edge-friendly and cost-aware">
        <ul className="list-disc list-inside space-y-2 text-slate-700">
          <li>Works with OpenAI free tier or HuggingFace Inference API.</li>
          <li>No long context; send only scores + key feedback to control tokens.</li>
          <li>Cache results in D1 (AIInsight table) with TTL to avoid re-calls.</li>
          <li>Stateless Cloudflare function keeps deployment simple.</li>
        </ul>
      </Card>
    </div>
  );
}

export default AiSummary;
